"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewTransactionPreset = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const useForm_1 = require("../../../../hooks/useForm");
const Button_1 = require("../../../Button");
const Field_1 = require("../../../Form/Field");
const SearchAccount_1 = require("../../../Form/Field/SearchAccount");
const utils_1 = require("../../../Form/Field/SearchAccount/utils");
require("./index.scss");
const className = 'new-transaction-preset';
const descriptor = {
    debit: useForm_1.allDescriptors.object(),
    credit: useForm_1.allDescriptors.object(),
    amount: useForm_1.allDescriptors.number({
        restrictions: {
            roundedMoney: true,
            positiveNumber: true,
            withoutZeroNumber: true,
        },
    }),
    category: useForm_1.allDescriptors.object(),
    description: useForm_1.allDescriptors.string(),
};
const NewTransactionPreset = (props) => {
    var _a, _b, _c, _d;
    const { config, submit, propsValues, validateForm, } = props;
    const { fields, values, isValid, validateAll } = (0, useForm_1.useForm)({ descriptor, config, propsValues, validateForm });
    const submitHandler = (0, react_1.useCallback)((e) => {
        e.preventDefault();
        if (!validateAll(values))
            return;
        submit(values);
    }, [submit, validateAll, values]);
    return (react_1.default.createElement("form", { className: className, onSubmit: submitHandler },
        react_1.default.createElement("div", { className: `${className}__from` },
            react_1.default.createElement(SearchAccount_1.SearchAccount, { value: fields.credit.value, setValue: fields.credit.onValue, query: fields.credit.searchInput, setQuery: fields.credit.onSearch, items: fields.credit.items, toItem: utils_1.mapAccountListItemToSearchAccountItemType, modificators: fields.credit.modifiers, required: (_b = (_a = config.credit) === null || _a === void 0 ? void 0 : _a.restrictions) === null || _b === void 0 ? void 0 : _b.required, disabled: fields.credit.disabled, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Form/NewTransaction/Preset:from', defaultMessage: 'From' }), error: fields.credit.error })),
        react_1.default.createElement("div", { className: `${className}__to` },
            react_1.default.createElement(SearchAccount_1.SearchAccount, { value: fields.debit.value, setValue: fields.debit.onValue, query: fields.debit.searchInput, setQuery: fields.debit.onSearch, items: fields.debit.items, toItem: utils_1.mapAccountListItemToSearchAccountItemType, modificators: fields.debit.modifiers, required: (_d = (_c = config.debit) === null || _c === void 0 ? void 0 : _c.restrictions) === null || _d === void 0 ? void 0 : _d.required, disabled: fields.debit.disabled, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Form/NewTransaction/Preset:to', defaultMessage: 'To' }), error: fields.debit.error })),
        react_1.default.createElement("div", { className: `${className}__amount` },
            react_1.default.createElement(Field_1.FormField, { value: fields.amount.input, onChange: fields.amount.onEvent, modificators: fields.amount.modifiers, disabled: fields.amount.disabled, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Form/NewTransaction/Preset:amount', defaultMessage: 'Amount' }), error: fields.amount.error })),
        react_1.default.createElement("div", { className: `${className}__description` },
            react_1.default.createElement(Field_1.FormField, { value: fields.description.input, onChange: fields.description.onEvent, modificators: fields.description.modifiers, error: fields.description.error, disabled: fields.description.disabled, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Form/NewTransaction/Advanced:description', defaultMessage: 'Description' }) })),
        react_1.default.createElement("div", { className: `${className}__button` },
            react_1.default.createElement(Button_1.Button, { type: 'submit', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Form/NewTransaction/Preset:submit', defaultMessage: 'Submit' }), disabled: !isValid }))));
};
exports.NewTransactionPreset = NewTransactionPreset;
//# sourceMappingURL=index.js.map